module.exports = __webpack_public_path__ + "static/media/tapbrick-2.9e248374.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/tapbrick-2.jpg
// module id = 110
// module chunks = 0